import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Loading, Empty, SectionHead, formatNum, formatDuration } from "../components/common";
import { Tv, Play } from "lucide-react";

const CATS = ["Home", "Live", "Trending", "Series", "Movies", "Music Videos", "Talk Shows", "Sports", "Gaming"];

export default function TV() {
  const [cat, setCat] = useState("Home");
  const [videos, setVideos] = useState([]);
  const [cont, setCont] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { setLoading(true); api.get(`/tv/videos?category=${encodeURIComponent(cat)}`).then(({ data }) => setVideos(data)).finally(() => setLoading(false)); }, [cat]);
  useEffect(() => { api.get("/tv/continue").then(({ data }) => setCont(data)).catch(() => {}); }, []);

  return (
    <div className="px-4 md:px-6 py-5">
      <div className="flex items-center gap-2 mb-5 overflow-x-auto hide-scroll">
        {CATS.map((c) => <button key={c} onClick={() => setCat(c)} data-testid={`tv-cat-${c.replace(/\s/g, "")}`} className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors ${cat === c ? "bg-white text-black" : "surface-2 text-muted-foreground hover:text-white"}`}>{c}</button>)}
      </div>

      {cont.length > 0 && cat === "Home" && (
        <div className="mb-8"><SectionHead title="Continue Watching" />
          <div className="flex gap-4 overflow-x-auto hide-scroll pb-2">{cont.map((v) => <VideoCard key={v.id} v={v} w="w-72" progress />)}</div>
        </div>
      )}

      {loading ? <Loading /> : videos.length === 0 ? <Empty icon={Tv} title="No shows yet" hint="VirtuStars+ creators can upload long-form programming to VStar TV." /> : (
        <>
          <SectionHead title={cat === "Home" ? "Featured" : cat} />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">{videos.map((v) => <VideoCard key={v.id} v={v} />)}</div>
        </>
      )}
    </div>
  );
}

export function VideoCard({ v, w = "", progress }) {
  return (
    <Link to={`/video/${v.id}`} className={`group surface rounded-xl overflow-hidden card-hover shrink-0 ${w}`} data-testid={`video-${v.id}`}>
      <div className="relative aspect-video bg-black">
        <img src={v.thumbnail_url} className="w-full h-full object-cover" alt="" loading="lazy" />
        <span className="absolute inset-0 flex items-center justify-center bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity"><span className="w-12 h-12 rounded-full btn-gold flex items-center justify-center"><Play size={20} /></span></span>
        <span className="absolute top-2 right-2 text-[10px] px-1.5 py-0.5 rounded bg-black/70">{v.category}</span>
        {v.duration > 0 && <span className="absolute bottom-2 right-2 text-[10px] font-medium px-1.5 py-0.5 rounded bg-black/80" data-testid={`video-duration-${v.id}`}>{formatDuration(v.duration)}</span>}
        {progress && v.progress > 0 && <div className="absolute bottom-0 inset-x-0 h-1 bg-white/20"><div className="h-full bg-eblue" style={{ width: `${Math.min(100, (v.progress / 120) * 100)}%` }} /></div>}
      </div>
      <div className="p-3"><div className="font-medium text-sm line-clamp-1">{v.title}</div><div className="text-xs text-muted-foreground mt-0.5">{v.channel?.display_name} · {formatNum(v.view_count)} views</div></div>
    </Link>
  );
}
